import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HomepageCaptchaGate } from "./HomepageCaptchaGate";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";

export function Layout() {
  const { pathname } = useLocation();
  const compactMain = pathname === "/web/servers" || pathname.startsWith("/web/servers/");
  const homeWide = pathname === "/";
  const askWide = pathname === "/ai-agents/ask";

  // Home: always start at the top so step 1 is not left under the sticky nav.
  useEffect(() => {
    if (pathname !== "/") return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <HomepageCaptchaGate>
      <div className={`site${homeWide ? " site--home" : ""}`}>
        <SiteHeader />
        <main
          className={`main${compactMain ? " main--compact" : ""}${homeWide ? " main--home-actions" : ""}${askWide ? " main--ask-full" : ""}`}
        >
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </HomepageCaptchaGate>
  );
}
